
import { useEffect, useState } from 'react';
import { useTelegramWebApp } from '@/hooks/useTelegramWebApp';

export const useTelegramWebAppSetup = () => {
  const { webApp, isReady: webAppReady, isTelegram } = useTelegramWebApp();
  const [isFullyReady, setIsFullyReady] = useState(false);

  useEffect(() => {
    if (webAppReady && webApp && isTelegram) {
      try {
        console.log('Setting up Telegram WebApp...');
        
        // Configure Telegram WebApp
        webApp.ready();
        webApp.expand();
        
        // Set header color to match our navy theme
        webApp.setHeaderColor('#19152a');
        
        // Hide main button initially
        webApp.MainButton.hide();

        // Show back button for navigation
        if (webApp.BackButton) {
          webApp.BackButton.show();
          
          // Handle back button navigation
          const handleBackButton = () => {
            console.log('Back button clicked in mini-app');
            // Get current view from URL
            const urlParams = new URLSearchParams(window.location.search);
            const currentView = urlParams.get('view');
            
            if (currentView && currentView !== 'dashboard') {
              // Navigate to dashboard
              const newUrl = new URL(window.location.href);
              newUrl.searchParams.set('view', 'dashboard');
              window.history.replaceState({ view: 'dashboard' }, '', newUrl.toString());
              window.dispatchEvent(new PopStateEvent('popstate'));
            } else {
              // Close mini-app if already on dashboard or no specific view
              if (webApp.close) {
                webApp.close();
              }
            }
          };
          
          // Remove any existing listeners and add new one
          webApp.BackButton.offClick(handleBackButton);
          webApp.BackButton.onClick(handleBackButton);
        }

        // Handle theme changes
        if (webApp.themeParams) {
          console.log('Applying Telegram theme:', webApp.themeParams);
          
          // Apply theme colors to CSS custom properties
          const root = document.documentElement;
          if (webApp.themeParams.bg_color) {
            root.style.setProperty('--tg-bg-color', webApp.themeParams.bg_color);
          }
          if (webApp.themeParams.text_color) {
            root.style.setProperty('--tg-text-color', webApp.themeParams.text_color);
          }
        }

        console.log('Telegram WebApp initialized successfully');
        console.log('WebApp user data:', webApp.initDataUnsafe);
        
        setIsFullyReady(true);
      } catch (error) {
        console.error('Error initializing Telegram WebApp:', error);
        setIsFullyReady(true); // Set ready anyway to prevent infinite loading
      }
    } else if (!isTelegram) {
      // For web version, mark as ready immediately
      console.log('Running in web mode (not Telegram)');
      setIsFullyReady(true);
    }
  }, [webAppReady, webApp, isTelegram]);

  return { 
    webApp, 
    isReady: isFullyReady, 
    isTelegram 
  };
};
